import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "file-text, document" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "Vector" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10 1.66675H5.83337C4.45266 1.66675 3.33337 2.78604 3.33337 4.16675V15.8334C3.33337 17.2141 4.45266 18.3334 5.83337 18.3334H14.1667C15.5474 18.3334 16.6667 17.2141 16.6667 15.8334V8.33342H12.5C11.1193 8.33342 10 7.21413 10 5.83342V1.66675ZM6.66671 11.6667C6.66671 11.2065 7.0398 10.8334 7.50004 10.8334H10C10.4603 10.8334 10.8334 11.2065 10.8334 11.6667C10.8334 12.127 10.4603 12.5001 10 12.5001H7.50004C7.0398 12.5001 6.66671 12.127 6.66671 11.6667ZM7.50004 14.1667C7.0398 14.1667 6.66671 14.5398 6.66671 15.0001C6.66671 15.4603 7.0398 15.8334 7.50004 15.8334H12.9167C13.3769 15.8334 13.75 15.4603 13.75 15.0001C13.75 14.5398 13.3769 14.1667 12.9167 14.1667H7.50004Z",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M16.1786 6.66675L11.6667 2.1549V5.83342C11.6667 6.29365 12.0398 6.66675 12.5 6.66675H16.1786Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }